import React from "react";
import { useAnimatedNumber } from "../useAnimatedNumber";

interface AnimatedScoreProps {
  value: number;
}
export const AnimatedScore: React.FC<AnimatedScoreProps> = ({ value }) => {
  const animatedValue = useAnimatedNumber(value);

  return (
    <div style={{
      marginTop: "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      transition: "color 0.3s",
      color: "#000"
    }}>
      <div style={{
        fontSize: "2.5em",
        fontWeight: "bold",
      }}>
        {animatedValue}
      </div>
      <div style={{
        fontSize: "0.9em",
        opacity: 0.6,
        marginTop: "4px"
      }}>
        Day Score
      </div>
    </div>
  );
};
